import request from '../../utils/request';

// 获取券列表数据
export function getVoucherList(params,authorization){
  return request({
    url: '/api/wx_shop/coupon/list',
    method: 'get',
    params,
    headers: {
      "authorization": authorization
    }
  })
}
// 获取商品列表数据
export function getProductList(params,authorization){
    return request({
      url: '/api/wx_shop/product/list',
      method: 'get',
      params,
      headers: {
        "authorization": authorization
      }
    })
  }






